import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import MfaqQuestionHeader from "@coworker/apprestructured/src/task-management/components/MfaqQuestionHeader/MfaqQuestionHeader";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

function MfaqQuestionHeaderDemo() {
  const [label, setLabel] = useState("Question");
  const [questionText, setQuestionText] = useState(
    "How do I reset my password?"
  );

  return (
    <Demo>
      <Name>MfaqQuestionHeader</Name>
      <Highlight>
        <MfaqQuestionHeader label={label} questionText={questionText} />
      </Highlight>
      <Actions>
        <FixaInputField
          label="label"
          type="text"
          id="tasktypeandtitledemo-label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
        <FixaInputField
          label="questionText"
          type="text"
          id="tasktypeandtitledemo-title"
          value={questionText}
          onChange={(e) => setQuestionText(e.target.value)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(MfaqQuestionHeaderDemo);
